/**
 * Centralized logging utility
 * Logs only in development mode, silent in production
 */

const isDevelopment = process.env.NODE_ENV === 'development';

const logger = {
    log: (...args) => {
        if (isDevelopment) {
            console.log(...args);
        }
    },

    warn: (...args) => {
        if (isDevelopment) {
            console.warn(...args);
        }
    },

    error: (...args) => {
        // Always log errors, even in production
        console.error(...args);
    },

    debug: (...args) => {
        if (isDevelopment) {
            console.debug(...args);
        }
    },

    info: (...args) => {
        if (isDevelopment) {
            console.info(...args);
        }
    },
};

export default logger;
